import axios from "axios";

export const API = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({ baseURL: `${API}/api` });

export const getAccessToken = () => localStorage.getItem("edalix_access_token");
export const getRefreshToken = () => localStorage.getItem("edalix_refresh_token");
export const setTokens = (access, refresh) => {
  localStorage.setItem("edalix_access_token", access);
  if (refresh) localStorage.setItem("edalix_refresh_token", refresh);
};
export const clearTokens = () => {
  localStorage.removeItem("edalix_access_token");
  localStorage.removeItem("edalix_refresh_token");
};

api.interceptors.request.use((config) => {
  const token = getAccessToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

let refreshing = null;
api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const original = error.config || {};
    const isAuthCall = (original.url || "").includes("/auth/");
    if (error.response?.status === 401 && !original._retry && !isAuthCall && getRefreshToken()) {
      original._retry = true;
      try {
        refreshing =
          refreshing ||
          axios.post(`${API}/api/auth/refresh`, { refresh_token: getRefreshToken() });
        const { data } = await refreshing;
        refreshing = null;
        setTokens(data.access_token, null);
        original.headers = { ...(original.headers || {}), Authorization: `Bearer ${data.access_token}` };
        return api(original);
      } catch (e) {
        refreshing = null;
        clearTokens();
        if (window.location.pathname.startsWith("/admin") && window.location.pathname !== "/admin/login") {
          window.location.href = "/admin/login";
        }
      }
    }
    return Promise.reject(error);
  }
);

export const imgSrc = (p) => {
  if (!p) return "";
  return p.startsWith("/api/") ? `${API}${p}` : p;
};

export const formatApiError = (err, fallback = "Algo deu errado. Tente novamente.") => {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : "")).filter(Boolean).join(" ") || fallback;
  return fallback;
};
